import styles from "./BillingInformationSettings.module.scss";
import { Icon } from "../../../atoms/Icon";
import React from "react";
import moment from "moment";
import FormHeading from "../../../atoms/FormHeading/FormHeading";
import { Callout, Intent } from "@blueprintjs/core";

export function InvoiceList({ invoices, balance }) {
  return (
    <>
      <div className={styles.row}>
        <div className={styles.headingHolder}>
          <FormHeading className={styles.heading} weight="600">
            Invoice History
          </FormHeading>
        </div>
      </div>
      {balance != 0 && (
        <Callout intent={Intent.SUCCESS} icon={null} className={styles.balance}>
          You have an account credit of ${balance}. Your credit balance will be
          applied to your monthly invoices and decrease the amount due.
        </Callout>
      )}
      <div className={styles.invoiceList}>
        {invoices.map((invoice) => (
          <div className={styles.listItem}>
            <div className={styles.col_1}>
              ${(invoice.amount / 100).toFixed(2)}
            </div>
            <div className={styles.col_2}>
              {moment(invoice.paidAt * 1000).format("DD-MMM-YYYY")}
            </div>
            <div className={styles.col_3}>
              <a className={styles.btnDownload} href={invoice.invoiceUrl}>
                <Icon name="download" size={14} color="#5c7080" />
              </a>
            </div>
          </div>
        ))}
        {invoices.length == 0 && <span>No invoices available</span>}
      </div>
    </>
  );
}
